import { createSlice } from "@reduxjs/toolkit";
import { initialFilter } from "../../pages/shipper-service/ShipperServiceUIHelpers";

const initialShipperServicesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  shipperServiceForEdit: undefined,
  lastError: null,
  filters: initialFilter
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const shipperServiceSlice = createSlice({
  name: "shipperServices",
  initialState: initialShipperServicesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getShipperServiceById
    shipperServiceFetched: (state, action) => {
      state.actionsLoading = false;
      state.shipperServiceForEdit = action.payload.shipperServiceForEdit;
      state.error = null;
    },
    // findShipperServices
    shipperServicesFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // getAllShipperService
    shipperServiceAllFetched: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.all = action.payload.all;
    },
    // createShipperService
    shipperServiceCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.shipperService);
    },
    // updateShipperService
    shipperServiceUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map((entity) => {
        if (entity.id === action.payload.shipperService.id) {
          return action.payload.shipperService;
        }
        return entity;
      });
    },
    shippingServiceFilter: (state, action) => {
      state.listLoading = false
      state.error = null
      state.filters = action.payload
    }
  },
});
